module.exports = __webpack_public_path__ + "media/images/oficinas/saladas-e318aa931a246f73789cad9186ac2da4.jpg";